"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _analytics = _interopRequireDefault(require("../entel/analytics"));
var _constants = require("../../../utils/constants");
var _logger = require("../../logger");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class AnalyticsServiceCL extends _analytics.default {
  constructor(params) {
    super(params);
    this.config = void 0;
    this.config = params;
    this.numberOfPlans = 0;
  }
  startJourney() {
    _logger.Logger.info({
      segments: [_logger.Logger.LOGGER_SEGMENTS.SERVICES, _logger.Logger.LOGGER_SEGMENTS.TAGGING]
    })('Chile Journey started ....');
  }
  getPlanPrice(variant, _) {
    var _this$config, _this$config$basicPla, _variant$price, _variant$price$find, _variant$price2, _variant$price2$find, _variant$price3, _variant$price3$find, _variant$price4, _variant$price4$find;
    const isBasicPlan = (_this$config = this.config) === null || _this$config === void 0 ? void 0 : (_this$config$basicPla = _this$config.basicPlanIds) === null || _this$config$basicPla === void 0 ? void 0 : _this$config$basicPla.some(text => text.includes(variant.variantId.split('-')[0]));
    return {
      productPrice: isBasicPlan ? variant === null || variant === void 0 ? void 0 : (_variant$price = variant.price) === null || _variant$price === void 0 ? void 0 : (_variant$price$find = _variant$price.find(_ref => {
        let {
          priceType
        } = _ref;
        return priceType === _constants.PRICE_TYPES.COMMERCE_ADDITIONAL_PLAN_PRICE;
      })) === null || _variant$price$find === void 0 ? void 0 : _variant$price$find.priceValue : variant === null || variant === void 0 ? void 0 : (_variant$price2 = variant.price) === null || _variant$price2 === void 0 ? void 0 : (_variant$price2$find = _variant$price2.find(_ref2 => {
        let {
          priceType
        } = _ref2;
        return priceType === _constants.PRICE_TYPES.COMMERCE_PRICE;
      })) === null || _variant$price2$find === void 0 ? void 0 : _variant$price2$find.priceValue,
      productSubprice: isBasicPlan ? variant === null || variant === void 0 ? void 0 : (_variant$price3 = variant.price) === null || _variant$price3 === void 0 ? void 0 : (_variant$price3$find = _variant$price3.find(_ref3 => {
        let {
          priceType
        } = _ref3;
        return priceType === _constants.PRICE_TYPES.LIST_ADDITIONAL_PLAN_PRICE;
      })) === null || _variant$price3$find === void 0 ? void 0 : _variant$price3$find.priceValue : variant === null || variant === void 0 ? void 0 : (_variant$price4 = variant.price) === null || _variant$price4 === void 0 ? void 0 : (_variant$price4$find = _variant$price4.find(_ref4 => {
        let {
          priceType
        } = _ref4;
        return priceType === _constants.PRICE_TYPES.RECURRING;
      })) === null || _variant$price4$find === void 0 ? void 0 : _variant$price4$find.priceValue
    };
  }
  showDiscount(flags) {
    return (flags === null || flags === void 0 ? void 0 : flags[_constants.FLAGS.IS_CUSTOMER]) || (flags === null || flags === void 0 ? void 0 : flags[_constants.FLAGS.BOTH_FLOW]);
  }
  composeTaggingEvents(eventsData) {
    var _currentQuestion$tagg, _TAP_TEXT_MAP$current;
    const {
      currentQuestion,
      noOfPlans,
      currentProduct,
      costs,
      flags
    } = eventsData;
    if (currentQuestion !== null && currentQuestion !== void 0 && (_currentQuestion$tagg = currentQuestion.taggingMetadata) !== null && _currentQuestion$tagg !== void 0 && _currentQuestion$tagg.keysToBeRemoved) {
      var _currentQuestion$tagg2;
      currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$tagg2 = currentQuestion.taggingMetadata) === null || _currentQuestion$tagg2 === void 0 ? void 0 : _currentQuestion$tagg2.keysToBeRemoved.forEach(e => {
        if (e === 'product_quantity') this.numberOfPlans = this.questionsAnswers['product_quantity'];
      });
    }
    const productData = super._getProductData(currentProduct, costs, flags);
    const CurrentProductTier = (currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.productType) === 'plan' ? (_TAP_TEXT_MAP$current = _constants.TAP_TEXT_MAP[currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.tier]) !== null && _TAP_TEXT_MAP$current !== void 0 ? _TAP_TEXT_MAP$current : currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.tier : currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.tier;
    const additionalBasketTaggingData = {
      ...(productData.product_category === 'plan' && {
        product_quantity: noOfPlans || this.questionsAnswers.product_quantity
      })
    };
    const taggingEvents = super.composeTaggingEvents({
      ...eventsData,
      currentQuestion,
      currentProduct,
      noOfPlans,
      CurrentProductTier,
      additionalBasketTaggingData,
      shouldHaveProductBrandTag: false
    });
    const productQuantity = {
      ...(productData.product_category === 'plan' && {
        product_quantity: this.questionsAnswers.product_quantity || this.numberOfPlans
      })
    };
    taggingEvents.onToolResult = {
      ...taggingEvents.onToolResult,
      ...productQuantity
    };
    taggingEvents.onToolResultNext = {
      ...taggingEvents.onToolResultNext,
      event_label: 'lo quiero'
    };
    taggingEvents.onToolResultTabSwitch = {
      ...taggingEvents.onToolResultTabSwitch,
      ...productQuantity
    };
    taggingEvents.onToolCompare = {
      ...taggingEvents.onToolCompare,
      event_label: productData.product_category === 'plan' ? 'comparar planes' : 'comparar equipos'
    };
    delete taggingEvents.onReopenRecommendation;
    return taggingEvents;
  }
}
var _default = AnalyticsServiceCL;
exports.default = _default;